var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"core_gateways"}},[_c('bank-gateways')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }